<p class="attrib_settings_container">
  <span class="attrib_setting_name">{{ displayName }}</span>
  <button mat-button class="attrib_clear_button" type="button" (click)="clearAttrib()">
    <mat-icon class="attrib_setting_clear_icon">close</mat-icon>
  </button>
</p>
<mat-radio-group [formControl]="control" class="button_radio-group">
  <mat-radio-button class="button_radio" (click)="setAttribValue(true)" [value]="true">
    {{ 'FRONTEND.FORMS.INPUT.YES' | translate }}
  </mat-radio-button>
  <mat-radio-button class="button_radio" (click)="setAttribValue(false)" [value]="false">
    {{ 'FRONTEND.FORMS.INPUT.NO' | translate }}
  </mat-radio-button>
</mat-radio-group>
